export default __webpack_public_path__ + "static/media/adio.5be3128f.jpg";